export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
			},
			{
				id: 2,
				text: "Der Dozent/Die Dozentin hat die Inhalte angemessen wiederholt.",
			},
			{
				id: 3,
				text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
			},
			{
				id: 4,
				text: "Der Dozent/die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
			},
			{
				id: 5,
				text: "Der Dozent/Die Dozentin gab die Möglichkeit, Themen zu diskutieren.",
			},
			{
				id: 6,
				text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
			},
			{
				id: 7,
				text: "Der Dozent/Die Dozentin war fachlich kompetent.",
			},
			{
				id: 8,
				text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
			},
			{
				id: 9,
				text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
			},
			{
				id: 10,
				text: "Der Dozent/Die Dozentin motivierte die Teilnehmer/innen.",
			},
			{
				id: 11,
				text: "Das Lernziel wurde mir deutlich.",
			},
			{
				id: 12,
				text: "Die angestrebten Lernziele wurden von vorneherein gut definiert.",
			},
			{
				id: 13,
				text: "Die Veranstaltung war übersichtlich und verständlich.",
			},
			{
				id: 14,
				text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
			},
			{
				id: 15,
				text: "Ich habe mich schon vor der Veranstaltung für das Thema interessiert.",
			},
			{
				id: 16,
				text: "Das Thema der Veranstaltung ist als solches relevant.",
			},
			{
				id: 17,
				text: "Ich habe das Gefühl in der Veranstaltung Wichtiges gelernt zu haben.",
			},
			{
				id: 18,
				text: "Das behandelte Thema enthält Bezüge zu meiner späteren Berufstätigkeit.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 19,
				text: "Die Schwere des Stoffes war...",
			},
			{
				id: 20,
				text: "Der Umfang des Stoffes war...",
			},
			{
				id: 21,
				text: "Das Tempo der Veranstaltung war...",
			},
			{
				id: 22,
				text: "Die Anforderungen der Veranstaltung waren...",
			},
			{
				id: 23,
				text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war...",
			},
			{
				id: 24,
				text: "Insgesamt empfand ich die Veranstaltung als...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 25,
				text: "Die Vortragsweise und Darbietung der Inhalte (in Referaten) ist ansprechend.",
			},
			{
				id: 26,
				text: "Die fachlich-inhaltliche Qualität der Referate ist hoch.",
			},
			{
				id: 27,
				text: "Ich lerne viel durch die Referate anderer Teilnehmender.",
			},
			{
				id: 28,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit dem / der Dozenten/in.",
			},
			{
				id: 29,
				text: "Es gab durch die Online-Tools ausreichend viel Möglichkeit zur Interaktion mit anderen Studierenden.",
			},
			{
				id: 30,
				text: "Die Online-Termine waren gut organisiert und leicht erreichbar.",
			},
			{
				id: 31,
				text: "Die Online-Materialien (z.B. Texte, Quizzes, Videos etc.) haben wesentlich zum Verständnis der Lerninhalte beigetragen.",
			},
			{
				id: 32,
				text: "Die Möglichkeiten digitaler Lehre über traditionelle Lehre hinaus (Diskussionsforen, interaktive Aufgaben etc.) wurden gut genutzt.",
			},
			{
				id: 33,
				text: "Insgesamt waren die digitalen Elemente der Veranstaltung gut.",
			},
			{
				id: 34,
				text: "Die Veranstaltung ist ein Beispiel für gute digitale Lehre.",
			},
			{
				id: 35,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 36,
				text: "In der Veranstaltung habe ich viel gelernt.",
			},
			{
				id: 37,
				text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
			},
			{
				id: 38,
				text: "Ich würde die Veranstaltung weiterempfehlen.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 39,
				text: "Sonstige Anmerkungen zu der Veranstaltung (Lob/Kritik)",
			},
			{
				id: 40,
				text: "Wie bewerten Sie das Engagement der Betreuer/innen und warum?",
			},
		],
	},
];
